export const columnStateMapping = {
  registered: ['registered'],
  qualifying: ['qualifying', 'qualifying_management_review', 'qualifying_finantial_review'],
  quoting: ['quoting', 'quoting_management_review', 'quoting_client_review'],
  negotiating: ['quoting_finalization'],
  completed: ['negotiating'],
}

export type ColumnKey = keyof typeof columnStateMapping
